import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SystemTypeState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: SystemTypeState = {
  data: [],
  isLoading: false,
  error: null,
};

const systemTypeSlice = createSlice({
  name: 'systemType',
  initialState,
  reducers: {
    setSystemTypes: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setSystemTypeLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSystemTypeError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setSystemTypes, setSystemTypeLoading, setSystemTypeError } = systemTypeSlice.actions;

export default systemTypeSlice.reducer;
